import React, { useState, useRef, useEffect } from "react";

const defaultProps = {
  user: {
    username: "Juan Dela Cruz",
    email: "juan@example.com",
    role: [{ id: "CLient" }],
    profile: null,
  },
};

function UserMenu({
  user,
  isAdmin,
  onClickProfile,
  onClickSettings,
  onClickLogout,
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const initial = user?.username?.charAt(0).toUpperCase();
  const Avatar = ({ size = 38 }) =>
    user?.profile ? (
      <img
        src={user.profile}
        alt="profile"
        className="rounded-circle object-fit-cover"
        width={size}
        height={size}
      />
    ) : (
      <div
        className="rounded-circle bg-primary bg-opacity-10 text-primary d-flex align-items-center justify-content-center fw-bold flex-shrink-0"
        style={{ width: size, height: size, fontSize: size * 0.4 }}
      >
        {initial}
      </div>
    );

  return (
    <div className="position-relative" ref={ref}>
      {/* Trigger Button */}
      <button
        onClick={() => setOpen((prev) => !prev)}
        type="button"
        className="btn btn-sm btn-link text-dark p-0"
      >
        <Avatar size={32} />
      </button>

      {open && (
        <div
          className="card shadow position-absolute end-0 mt-1"
          style={{ width: "260px", zIndex: 1050 }}
        >
          {/* Header — matches NotificationMenu card-header */}
          <div className="card-header d-flex align-items-center gap-3 py-2">
            <Avatar size={38} />
            <div className="overflow-hidden">
              <p className="mb-0 fw-semibold text-truncate small">
                {user?.username}
              </p>
              <p
                className="mb-0 text-muted text-truncate"
                style={{ fontSize: "12px" }}
              >
                {user?.email}
              </p>
              <span
                className="badge bg-primary bg-opacity-10 text-primary"
                style={{ fontSize: "11px" }}
              >
                {user?.roles[0]?.id}
              </span>
            </div>
          </div>

          {/* Menu Items — matches NotificationMenu list-group */}
          <ul className="list-group list-group-flush">
            <li
              className="list-group-item list-group-item-action d-flex align-items-center gap-3 py-3"
              style={{ cursor: "pointer" }}
              onClick={() => {
                onClickProfile?.();
                setOpen(false);
              }}
            >
              <div
                className="d-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 text-primary flex-shrink-0"
                style={{ width: "38px", height: "38px" }}
              >
                <i className="bi bi-person"></i>
              </div>
              <div>
                <p className="mb-0 fw-semibold small">Profile</p>
                <p className="mb-0 text-muted" style={{ fontSize: "12px" }}>
                  View and edit your profile
                </p>
              </div>
            </li>
            {isAdmin && (
              <li
                className="list-group-item list-group-item-action d-flex align-items-center gap-3 py-3"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  onClickSettings?.();
                  setOpen(false);
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle bg-primary bg-opacity-10 text-primary flex-shrink-0"
                  style={{ width: "38px", height: "38px" }}
                >
                  <i className="bi bi-gear"></i>
                </div>
                <div>
                  <p className="mb-0 fw-semibold small">System Settings</p>
                  <p className="mb-0 text-muted" style={{ fontSize: "12px" }}>
                    Manage system preferences
                  </p>
                </div>
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
}

UserMenu.defaultProps = defaultProps;
export default UserMenu;
